import feathersClient from '../setup/feathersClient';
import feathersReduxifyAuthentication from '../utils/reduxify-feathers-auth';

export default feathersReduxifyAuthentication(
  feathersClient,
  {
    isUserAuthorized: user => user.active
  } // WE INSIST USER IS 'verified' TO AUTHENTICATE
);
